import { useLoadScript } from '@react-google-maps/api';

const libraries = ['places'];

export default function useConfigureGoogleMaps() {
  // Loading the Google Maps script should only happen once, when the application is loaded.

  const { loadError } = useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    // Load the `weekly` channel, which carries the Places API (New) surface
    // this app now uses (Autocomplete Data API, Place). It is also the loader
    // default; set explicitly to document the dependency (not a version pin).
    version: 'weekly',
    libraries,
  });

  if (loadError) {
    // eslint-disable-next-line no-console
    console.error(loadError);
  }
}
